import { useQuery } from '@apollo/client/react';
import { GET_PRODUCTS_DATA_QUERY } from '../../integrations/allkort/graphql/gql/Products';
import { Product, ProductsDataResponse } from '../../integrations/allkort/graphql/interface/Products';

const PRODUCTS_PER_PAGE = 50;

/**
 * Custom hook for fetching all available products (fuel types, etc.)
 * Uses cache-first policy since products rarely change
 * 
 * Usage:
 * const { products, loading, error } = useGetProducts();
 * 
 * @returns Object with products array, loading state, and error
 */
export const useGetProducts = () => {
	const { data, loading, error } = useQuery<ProductsDataResponse>(
		GET_PRODUCTS_DATA_QUERY,
		{
			variables: {
				first: PRODUCTS_PER_PAGE,
				after: null,
				before: null,
				last: null
			},
			fetchPolicy: 'cache-first', // Products don't change often, use cache
		}
	);

	const products: Product[] = data?.products?.nodes ?? [];

	return {
		products,
		loading,
		error,
		// Expose pageInfo in case pagination is needed later
		pageInfo: data?.products?.pageInfo,
		// Helper to check if there are more products to fetch
		hasMore: data?.products?.pageInfo?.hasNextPage ?? false,
	};
};
